import { css } from '@linaria/core';
import { theming } from 'styles/utils';
import { textSmall } from 'styles/typography';
export const regularFormGroupEl = "omponents__ui_library__Formik__Formik_styles_tsx-regularFormGroupEl-r1rqjniz";
export const formGroupEl = "omponents__ui_library__Formik__Formik_styles_tsx-formGroupEl-f1gbw6a3";
export const fieldWrapper = "omponents__ui_library__Formik__Formik_styles_tsx-fieldWrapper-f19n4njh";
export const formLabel = `${"omponents__ui_library__Formik__Formik_styles_tsx-formLabel-f14qsn7o"}
  ${textSmall}
`;
export const labelStyle = "omponents__ui_library__Formik__Formik_styles_tsx-labelStyle-l4uxvv6";
export const errorMsg = `${"omponents__ui_library__Formik__Formik_styles_tsx-errorMsg-e13z4h1s"}
  ${textSmall}
`;
export const hintStyle = `${"omponents__ui_library__Formik__Formik_styles_tsx-hintStyle-h1rveiu8"}
  ${textSmall}
  `;
export const suffixStyle = "omponents__ui_library__Formik__Formik_styles_tsx-suffixStyle-s1yytsg2";
export const multiLineInputStyle = "omponents__ui_library__Formik__Formik_styles_tsx-multiLineInputStyle-mib1gee";
export const checkboxLabelStyle = "omponents__ui_library__Formik__Formik_styles_tsx-checkboxLabelStyle-c1ps3fn1";

require("./Formik.styles.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Formik.styles.tsx");